import {
  workflowApiRef,
  WorkflowClient,
  triggerApiRef,
  TriggerClient,
} from './api';
import { rootRouteRef } from './routes';
import {
  createPlugin,
  createApiFactory,
  createRoutableExtension,
  createComponentExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

/** @public */
export const cloudbuildPlugin = createPlugin({
  id: 'cloudbuild',
  apis: [
    createApiFactory({
      api: workflowApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory({ discoveryApi, fetchApi }) {
        return new WorkflowClient({ discoveryApi, fetchApi });
      },
    }),
    createApiFactory({
      api: triggerApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory({ discoveryApi, fetchApi }) {
        return new TriggerClient({ discoveryApi, fetchApi });
      },
    }),
  ],
  routes: {
    entityContent: rootRouteRef,
  },
});

/** @public */
export const EntityCloudbuildContent = cloudbuildPlugin.provide(
  createRoutableExtension({
    name: 'EntityCloudbuildContent',
    component: () => import('./components/Router').then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);

/** @public */
export const EntityLatestCloudbuildRunCard = cloudbuildPlugin.provide(
  createComponentExtension({
    name: 'EntityLatestCloudbuildRunCard',
    component: {
      lazy: () =>
        import('./components/Workflow/Cards').then(
          m => m.LatestWorkflowRunCard,
        ),
    },
  }),
);

/** @public */
export const EntityLatestCloudbuildsForBranchCard = cloudbuildPlugin.provide(
  createComponentExtension({
    name: 'EntityLatestCloudbuildsForBranchCard',
    component: {
      lazy: () =>
        import('./components/Workflow/Cards').then(
          m => m.LatestWorkflowsForBranchCard,
        ),
    },
  }),
);
